import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseTableComponent } from '../base-table/base-table.component';
import { PaymentDiscount } from 'src/app/entities/payment-discount';
import { PaymentDiscountService } from 'src/app/services/payment-discount.service';
import { AlertService } from 'src/app/services/alert.service';
import { fuseAnimations } from '@mobileia/layout-fuse';

@Component({
  selector: 'app-payment-discount',
  templateUrl: './payment-discount.component.html',
  styleUrls: ['./payment-discount.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class PaymentDiscountComponent extends BaseTableComponent<PaymentDiscount> implements OnInit {

  displayedColumns = ['id', 'title', 'type_id', 'from', 'to', 'status', 'actions'];
  configColumns = [
    {
      key: 'id',
      field_key: 'id',
      type: 'integer',
      title: 'ID',
      classes: 'font-weight-600'
    },
    {
      key: 'title',
      field_key: 'title',
      type: 'string',
      title: 'Titulo',
      classes: ''
    },
    {
      key: 'type_id',
      field_key: 'type_id',
      type: 'option',
      title: 'Tipo',
      classes: '',
      options: {
        '0': {
          title: ''
        },
        '1': {
          title: 'MutualCard'
        },
        '2': {
          title: 'Efectivo'
        },
      }
    },
    {
      key: 'from',
      field_key: 'from',
      type: 'string',
      title: 'Desde',
      classes: ''
    },
    {
      key: 'to',
      field_key: 'to',
      type: 'string',
      title: 'Hasta',
      classes: ''
    },
    {
      key: 'status',
      field_key: 'status',
      type: 'option',
      title: 'Estado',
      classes: '',
      options: {
        '0': {
          title: 'Inactivo'
        },
        '1': {
          title: 'Activo'
        },
      }
    },
  ];

  constructor(
    protected discountService: PaymentDiscountService,
    protected alertService: AlertService
  ) {
    super(alertService);
    this.service = discountService;
  }

  ngOnInit(): void {
    this.loadItems();
  }

}